/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pale_Rich_Robin_BurnInputs */

const en_pale_rich_robin_burn = /** @type {(inputs: Pale_Rich_Robin_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup access for all accessible reports`)
};

const de_pale_rich_robin_burn = /** @type {(inputs: Pale_Rich_Robin_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriff für alle freigegeben Berichte setzen`)
};

/**
* | output |
* | --- |
* | "Setup access for all accessible reports" |
*
* @param {Pale_Rich_Robin_BurnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pale_rich_robin_burn = /** @type {((inputs?: Pale_Rich_Robin_BurnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pale_Rich_Robin_BurnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pale_rich_robin_burn(inputs)
	return de_pale_rich_robin_burn(inputs)
});